import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing } from "../../util/styles.js";

export const JobListingsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssSpacing("s")};
`;

export const JobCard = styled.div<{ href?: string }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  background: var(--job-listings-card-background);
  border-radius: ${(props) => props.theme.borderRadius};
  border: 2px solid transparent;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.2s;

  &:hover {
    border-color: var(--job-listings-card-border-color);
  }
`;

export const JobCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${cssSpacing("xs")};
  padding: ${cssSpacing("s")};
`;

export const JobCardTitle = styled.h3`
  margin: 0;
  font-size: ${cssFontSize("medium")};
  color: var(--job-listings-card-title-color);
`;

export const JobCardDescription = styled.p`
  margin: 0;
  font-size: ${cssFontSize("small")};
  color: var(--job-listings-card-description-color);
  line-height: 1.5;
`;

export const JobCardMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${cssSpacing("xs")} ${cssSpacing("s")};
  margin-top: auto;

  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    flex-direction: row;
    gap: ${cssSpacing("m")};
  }
`;

export const JobCardMetaItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: var(--job-listings-icon-color);

    path {
      fill: none;
    }
  }
`;

export const JobCardMetaLabel = styled.span`
  display: block;
  font-size: ${cssFontSize("tiny")};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--job-listings-card-meta-label-color);
`;

export const JobCardMetaValue = styled.span`
  display: block;
  font-size: ${cssFontSize("small")};
  color: var(--job-listings-card-meta-value-color);
`;

export const LoadMore = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${cssSpacing("m")};
`;

export const JobCardImage = styled.img`
  display: none;
  flex-shrink: 0;
  object-fit: cover;

  @media (min-width: ${mobileBreakPointCSS}) {
    display: block;
    width: 300px;
    height: auto;
  }
`;
